var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0C18.816 0 0 18.816 0 42C0 65.184 18.816 84 42 84C65.184 84 84 65.184 84 42C84 18.816 65.184 0 42 0Z",
    fill: "#E8EBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6808 32.1808C55.6808 24.6368 49.544 18.5 42 18.5C34.456 18.5 28.3192 24.6368 28.3192 32.1808C28.3192 39.7248 34.456 45.8616 42 45.8616C49.544 45.8616 55.6808 39.7248 55.6808 32.1808Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59.9658C24.684 68.0179 34.0651 71.2231 42 71.2231C49.9349 71.2231 59.316 68.0179 66 59.9658C59.3941 54.8062 51.0684 51.6791 42 51.6791C32.9316 51.6791 24.6059 54.8062 18 59.9658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnProfile);
export default __webpack_public_path__ + "static/media/icn_profile.3eefc4591e17a9a1a6a22614e445284e.svg";
export { ForwardRef as ReactComponent };